import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { vehicles } from "../../../../../../redux/vehicles/action";
import { selectVehiclesListItems } from "../../../../../../redux/vehicles/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import MobileViewTable from "../../../../../../common/components/mobile-view-table.component";
import InfiniteScroll from "react-infinite-scroll-component";

const TransportAgentVehiclesMobile = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [index, setIndex] = useState(1)
  const [hasMore, setHasMore] = useState();
  const itemsData = useSelector(selectVehiclesListItems)
  const [rawData, setRawData] = useState<any>([])
  const [vehicleData, setVehicleData] = useState<any>([])
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'RegistrationNumber', headerName: 'Registration Number', sortable: true, filter: true, isEdit: true },
      { field: 'VehicleName', headerName: 'Vehicle Name', sortable: true, filter: true, search: true },
      { field: 'LoadingCapacity', headerName: 'Loading Capacity(kg)' },
      { field: 'VehicleWeight', headerName: 'Vehicle Weight(kg)', sortable: false, filter: true },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
    ]);
  }
  const fetchVehicls = async (_page: any, size: any) => {
    await dispatch(vehicles.resetAction({ actionType: 'list' }))
    await dispatch(vehicles.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/list`, entity: 'vehicles', jsonData: {
        "PageNumber": _page,
        "PageSize": size,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))

  }
  useEffect(() => {
    createColumnDefs()
    fetchVehicls(index, 10)
  }, [])

  useEffect(() => {
    if (index > 1) {
      createColumnDefs()
      fetchVehicls(index, 10)
    }

  }, [index])

  useEffect(() => {
    if (itemsData?.result?.items) {
      setRawData(itemsData?.result?.items)
      setHasMore(itemsData?.result?.pagination?.HasNextPage)
    }
  }, [itemsData]);

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleDelete = async (data: any) => {
    await dispatch(vehicles.delete({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/delete`,
      entity: 'vehicles',
      jsonData: {
        Records: [
          {
            Id: data.Id
          }
        ]
      }
    }))
    await setVehicleData([])
    await fetchVehicls(index, 10)
  }
  const handleSearch = async (data: any) => {

    const searchCriteria = [{
      FieldName: "VehicleName",
      FieldText: "VehicleName",
      FieldType: 'text',
      FilterOperatorId: 6,
      FieldValue: data?.value
    }]
    await setVehicleData([])
    await dispatch(vehicles.resetAction({ actionType: 'list' }))
    await dispatch(vehicles.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/list`, entity: 'vehicles', jsonData: {
        "PageNumber": index,
        "PageSize": 30,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,

      }
    }));
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }
  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Vehicle</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload cards</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handlereload(),
    }
  ];
  const handlereload = async () => {
    await setVehicleData([])
    await fetchVehicls(index, 10)
  }

  const fetchMoreData = () => {
    const prevIndex = index
    setIndex(prevIndex + 1);
  };

  useEffect(() => {
    let formatedData = []
    rawData.map((data: any) => {
      formatedData.push({

        Id: data?.Id,
        RegistrationNumber: data?.RegistrationNumber,
        VehicleName: data?.VehicleName,
        LoadingCapacity: data?.LoadingCapacity,
        VehicleWeight: data?.VehicleWeight,
        CreatedOnUtc: data?.CreatedOnUtc,
        ModifiedOnUtc: data?.ModifiedOnUtc,

      })
    })
    if (index > 1) {
      setVehicleData([...vehicleData, ...formatedData])
    } else {
      setVehicleData(formatedData)
    }

  }, [rawData])

  return (
    <>
      {itemsData?.isLoading && index == 1 ? <PageLoader />
        :
        <MobileViewTable
          fetchMoreData={fetchMoreData}
          hasMore={hasMore}
          dataLength={vehicleData.length}
          onSearch={handleSearch}
          columnData={columnDefs}
          rowData={vehicleData}
          onEdit={handleEdit}
          additionButtons={additionButtons}
          onDelete={handleDelete}
          headingName="Vehicles" />
      }
    </>
  );
};

export default TransportAgentVehiclesMobile;


